/* ============
 * subscriberList Transformer
 * ============
 */

import Transformer from './transformer';

export default class SubscriberListTransformer extends Transformer {

  static fetch(subscriberList) {
    return {
      id: subscriberList.id,
      name: subscriberList.name,
      fromName: subscriberList.fromName,
      fromEmail: subscriberList.fromEmail,
      description: subscriberList.description,
      doubleOptinRequired: subscriberList.doubleOptinRequired,
      optinEmailSubject: subscriberList.optinEmailSubject,
      optinEmailBody: subscriberList.optinEmailBody,
      emailCount: subscriberList.email_count,
    };
  }

  static send(subscriberList) {
    return {
      name: subscriberList.name,
      fromName: subscriberList.fromName,
      fromEmail: subscriberList.fromEmail,
      description: subscriberList.description,
      doubleOptinRequired: subscriberList.doubleOptinRequired,
      optinEmailSubject: subscriberList.optinEmailSubject,
      optinEmailBody: subscriberList.optinEmailBody,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/subscriberList.js